import React from 'react';
import PendingReviews from '../DELIVERY/Review/PendingReviews';

const PendingReviewsSection = () => {
  return <PendingReviews />;
};

export default PendingReviewsSection;
